module.exports = __webpack_public_path__ + "img/smiling-doctor.fdbb224b.jpg";